import { commonDefaultSettings } from '../commonDefaultSettings';

/**
  @deprecated константа заменена на хук. Например: choiceSettings => useChoiceSettings
*/

export const emailSettings = {
  ...commonDefaultSettings,
  label: 'Email',
  placeholder: '',
  hint: '',
  required: true,
  fieldID: 'email',
  name: 'email'
};
